module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cfilter is-hidden-mobile"
  }, [_c('div', {
    staticClass: "cfilter_inner"
  }, [_c('input', {
    attrs: {
      "id": "tab-1",
      "name": "buttons",
      "type": "radio",
      "value": "all"
    },
    domProps: {
      "checked": true
    },
    on: {
      "click": _vm.filterClients
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tab-1"
    }
  }, [_c('div', {
    staticClass: "cfilter_inner__tab"
  }, [_c('h2', [_c('icon', {
    staticClass: "fa fa-eye",
    attrs: {
      "name": "eye"
    }
  }), _vm._v("\n        All Clients\n        ")], 1), _vm._v(" "), _vm._m(0)])]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "tab-2",
      "name": "buttons",
      "type": "radio",
      "value": "agency"
    },
    on: {
      "click": _vm.filterClients
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tab-2"
    }
  }, [_c('div', {
    staticClass: "cfilter_inner__tab"
  }, [_c('h2', [_c('icon', {
    staticClass: "fa fa-institution",
    attrs: {
      "name": "institution"
    }
  }), _vm._v("\n          Agencies\n        ")], 1), _vm._v(" "), _vm._m(1)])]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "tab-3",
      "name": "buttons",
      "type": "radio",
      "value": "seo"
    },
    on: {
      "click": _vm.filterClients
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tab-3"
    }
  }, [_c('div', {
    staticClass: "cfilter_inner__tab"
  }, [_c('h2', [_c('icon', {
    staticClass: "fa fa-bar-chart",
    attrs: {
      "name": "bar-chart"
    }
  }), _vm._v("\n          SEO\n        ")], 1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "tab-4",
      "name": "buttons",
      "type": "radio",
      "value": "dev"
    },
    on: {
      "click": _vm.filterClients
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tab-4"
    }
  }, [_c('div', {
    staticClass: "cfilter_inner__tab"
  }, [_c('h2', [_c('icon', {
    staticClass: "fa fa-desktop",
    attrs: {
      "name": "wordpress"
    }
  }), _vm._v("\n          Web Development\n        ")], 1), _vm._v(" "), _vm._m(3)])]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "tab-5",
      "name": "buttons",
      "type": "radio",
      "value": "code"
    },
    on: {
      "click": _vm.filterClients
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tab-5"
    }
  }, [_c('div', {
    staticClass: "cfilter_inner__tab"
  }, [_c('h2', [_c('icon', {
    staticClass: "fa fa-desktop",
    attrs: {
      "name": "code"
    }
  }), _vm._v("\n          Programming\n        ")], 1), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('input', {
    attrs: {
      "id": "tab-6",
      "name": "buttons",
      "type": "radio",
      "value": "design"
    },
    on: {
      "click": _vm.filterClients
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "tab-6"
    }
  }, [_c('div', {
    staticClass: "cfilter_inner__tab"
  }, [_c('h2', [_c('icon', {
    staticClass: "fa fa-desktop",
    attrs: {
      "name": "desktop"
    }
  }), _vm._v("\n          Web Design\n        ")], 1), _vm._v(" "), _vm._m(5)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("Visible is proud to have worked with a plethora of clients on projects including web development, SEO, and much more.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("Visible has built and maintained strong relationships with some of the top agencies in Chicago and around the nation.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("Visible has worked with countless clients and partners to improve their search traffic. ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("Visible has built sites from the ground up for hundreds of clients.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("Visible provides custom programming solutions on both the front-end and back-end, as well as debugging.")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "details"
  }, [_c('p', [_vm._v("Visible either designs or works with top designers to provide an incredible user experience for our client's sites.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14608002!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/clientfilter.vue
// module id = 106
// module chunks = 2